import PropTypes from 'prop-types'
import { Link } from 'wouter'

export default function SubMenuItems({ submenu, location, isSidebarOpen }) {
  return (
    <li className="flex" title={submenu?.title} key={submenu?.title}>
      {/* 
        Explicación de las validaciones en 'className':
          - Cuando la barra lateral está cerrada, se agrega 'whitespace-nowrap' para evitar saltos de línea en el texto.
          - Se valida si el usuario ha accedido al ítem actual. Si es así, se resalta el ítem.
          - Si el ítem está activo pero no se cumplen las condiciones anteriores, se le agrega una animación de hover.  
      */}
      <Link
        href={submenu.slug}
        className={`inline-flex pr-3 pl-4 ml-2.5 py-1.5 text-base text-white duration-300 grow border-s-2 ${!isSidebarOpen && 'whitespace-nowrap'} ${
          submenu?.slug === location
            ? 'bg-white/20 border-white *:text-white font-semibold'
            : submenu?.active &&
              'border-transparent hover:bg-white/10 hover:border-white/50'
        }`}
      >
        <div className="w-1/6">{submenu?.icon}</div>

        <div
          className={`w-5/6 ml-3 flex items-center uppercase origin-left duration-75 ${!isSidebarOpen && 'scale-0'}`}
        >
          <span>{submenu?.title}</span>
        </div>
      </Link>
    </li>
  )
}

// Define los tipos de las props que recibe el componente actual
SubMenuItems.propTypes = {
  submenu: PropTypes.object,
  location: PropTypes.any,
  isSidebarOpen: PropTypes.any
}
